<template>
  <v-menu
    ref="menuDate"
    v-model="menuDate"
    :return-value="date"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    content-class="elevation-1 custom-width-menu"
    :disabled="isDisable"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formatDate(date)"
        autocomplete="off"
        dense
        v-on="on"
        v-bind="attrs"
        :outlined="isOutlined"
        hide-details
        :placeholder="pickerPlaceholder"
        readonly
        clearable
        :label="label"
        class="v-input--datepicker"
        :class="classList"
        :disabled="isDisable"
        @click:clear="doClear"
      >
        <template slot="append">
          <svg-icon icon="calendar" @click="menuDate = true"></svg-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      locale="ja-jp"
      color="#e40013"
      :min="min"
      :max="max"
      :reactive="true"
      :day-format="(date) => new Date(date).getDate()"
      @change="save"
      @input="onInputDate"
      :type="type"
      :disabled="isDisable"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment';
const DATE_FORMAT = 'YYYY/MM/DD';
const MONTH_FORMAT = 'YYYY/MM';

export default {
  name: 'DatePicker',
  props: {
    label: { type: String, default: null },
    min: { type: String, default: null },
    max: { type: String, default: null },
    isDisable: { type: Boolean, default: false },
    dateFormat: { type: String, default: 'YYYY/MM/DD' },
    classList: { type: [String, Object], default: '' },
    isOutlined: { type: Boolean, default: true },
    valueInit: { type: String, default: null },
    placeholder: { type: String, default: 'YYYY/MM/DD' },
    type: { type: String, default: 'date' },
  },
  data () {
    return {
      menuDate: '',
      date: null,
    };
  },
  created () {
    if (this.valueInit) {
      this.date = this.valueInit;
    }
  },
  methods: {
    onInputDate () {
      this.$emit('input', this.date);
    },
    doClear () {
      this.date = null;
      this.$emit('input', this.date);
      this.$emit('setClearDate');
    },
    save (date) {
      this.$refs.menuDate.save(date);
      this.$emit('input', this.date);
    },
    formatDate (value) {
      if (value) {
        if (this.type === 'month') {
          return moment(value).format(MONTH_FORMAT);
        }
        return moment(value).format(DATE_FORMAT);
      }
    },
  },
  computed: {
    pickerPlaceholder () {
      return this.type === 'month' ? MONTH_FORMAT : DATE_FORMAT;
    },
  },
  watch: {
    valueInit (newVal) {
      // this.date = this.$commonHelper.formatDate(newVal);
      this.date = newVal;
    },
  },
};
</script>
<style scoped>
  .custom-width-menu {
    min-width: auto !important;
  }
</style>
